module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-1.0697f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-1.jpg
// module id = FkvI
// module chunks = 52